import get from 'lodash/get';
import { createSelector } from 'reselect';
import { makeSelectAccountPerks } from '../User/selectors';
import { PLAN_NAMES, BILLING_DURATIONS } from './constants';

/**
 * Direct selector to the subscriptionPlans state domain
 */
const selectSubscriptionPlansDomain = (state) =>
  get(state, 'subscriptionPlans');

const selectActiveSubscriptionPlanDomain = createSelector(
  makeSelectAccountPerks,
  selectSubscriptionPlansDomain,
  (perkMetadata, subscriptionPlans) => {
    //eslint-disable-line

    const stripePlanId = get(perkMetadata, 'tier.stripePlanId');
    if (!stripePlanId) {
      return {};
    }

    const plans = get(subscriptionPlans, 'plans.plans', []);
    const planCount = plans.length;
    let activePlan = null;

    let i = 0;
    while (activePlan === null && i < planCount) {
      const planToCompare = plans[i].subscriptionPlan;
      for (let j = 0; j < planToCompare.length; j += 1) {
        if (planToCompare[j].stripePlanId === stripePlanId) {
          activePlan = {
            isVisible: plans[i].isVisible,
            alias: plans[i].alias,
            plan: planToCompare[j],
          };
          break;
        }
      }

      i += 1;
    }
    return activePlan || {};
  },
);

/**
 * Other specific selectors
 */

/**
 * Default selector used by SubscriptionPlans
 */

const makeSelectSubscriptionPlans = createSelector(
  selectSubscriptionPlansDomain,
  (substate) => substate.plans,
);

const makeSelectPricingFeatures = createSelector(
  selectSubscriptionPlansDomain,
  (substate) => substate.pricingFeatures,
);

const makeSelectBillingCycle = createSelector(
  selectSubscriptionPlansDomain,
  (substate) => substate.selectedBillingCycle,
);

const makeSelectActiveSubscriptionPlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activeSubscriptionPlan) => activeSubscriptionPlan,
);

const makeSelectIsCustomPlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activePlan) => activePlan.isVisible === false,
);

const makeSelectIsPayingPlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activePlan) => {
    const { alias = '' } = activePlan;
    return (
      alias.toLowerCase().includes(PLAN_NAMES.elite) ||
      alias.toLowerCase().includes(PLAN_NAMES.pro)
    );
  },
);

const makeSelectIsProPlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activePlan) => {
    const { alias = '' } = activePlan;
    return alias.toLowerCase().includes(PLAN_NAMES.pro);
  },
);

const makeSelectIsElitePlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activePlan) => {
    const { alias = '' } = activePlan;
    return (
      alias.toLowerCase().includes(PLAN_NAMES.elite) ||
      alias.toLowerCase().includes(PLAN_NAMES.enterprise)
    );
  },
);

const makeSelectIsYearlyPlan = createSelector(
  selectActiveSubscriptionPlanDomain,
  (activePlan) =>
    get(activePlan, 'plan.timeInterval', '')
      .toLowerCase()
      .includes(BILLING_DURATIONS.yearly),
);

export {
  makeSelectSubscriptionPlans,
  makeSelectPricingFeatures,
  makeSelectBillingCycle,
  makeSelectActiveSubscriptionPlan,
  makeSelectIsCustomPlan,
  makeSelectIsPayingPlan,
  makeSelectIsProPlan,
  makeSelectIsElitePlan,
  makeSelectIsYearlyPlan,
};
